import React from 'react';

import PropTypes from 'prop-types';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';

const ValidationPopup = ({ data, ...props }) => (
    <SimplePopup
        popupRef={props.popupRef}
        withoutCloseButton
        text={
            <>
                <p>{data.messages.invalidBalanceText}</p>
                <p>{data.messages.repaymentSending1}</p>
                <p>{data.messages.repaymentSending2}</p>
            </>
        }
    >
        <PopupButton
            iconName="plus"
            href={`/auth/ga/pocket/${props.pocketId}/top-up`}
            text={data.messages.addMoneyButton}
            onClick={() => {
                props.popupRef.current?.close();
            }}
        />
        <PopupButton
            iconName="arrow-exchange"
            href={`/auth/ga/pocket/${props.pocketId}/exchange`}
            text={data.messages.exchangeMoneyButton}
            onClick={() => {
                props.popupRef.current?.close();
            }}
        />
    </SimplePopup>
);

ValidationPopup.propTypes = {
    data: PropTypes.any,
    pocketId: PropTypes.any,
};

export default ValidationPopup;
